import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Accordion, ContactUs, TawkChat } from "@/components";
import { UserIcon } from "@/svgs";
import "./HowItWorks.css";

interface CustomWindow extends Window {
  Tawk_API?: any;
  Tawk_LoadStart?: Date;
}
declare const window: CustomWindow;

const HowItWorksScreen: React.FC = () => {
  const navigate = useNavigate();

  const faqItems = {
    "Como funciona o Mimo Cupido?":
      "O Mimo Cupido é uma plataforma de relacionamento de alto padrão que conecta pessoas com objetivos compatíveis através de um sistema de matchmaking premium. Para participar, basta criar um perfil completo, preencher suas preferências e aguardar a análise da equipe de moderação. Após a aprovação, você poderá interagir com outros membros da comunidade de forma segura e discreta.",

    "O Mimo Cupido é seguro?":
      "Sim. A plataforma utiliza verificação manual de perfis, análise de fotos e moderação ativa para garantir um ambiente seguro. Além disso, contamos com políticas rígidas de privacidade e proteção de dados, criando uma experiência confiável para todos os usuários.",

    "Quanto tempo demora para ser aprovado?":
      "O tempo médio de aprovação é de até 24 horas. Perfis completos com fotos reais e informações detalhadas costumam ser analisados mais rapidamente dentro da fila de moderação.",

    "O cadastro no Mimo Cupido é gratuito?":
      "Sim. O cadastro é gratuito para novos usuários. A plataforma permite criar um perfil e participar do processo de análise sem custo inicial.",

    "Posso usar o Mimo Cupido em qualquer cidade do Brasil?":
      "Sim. O Mimo Cupido possui usuários em diversas regiões do Brasil, permitindo conexões entre pessoas de diferentes cidades com base em compatibilidade e preferências.",
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="v2-body">
      <TawkChat />

      <div className="v2-hero">
        <img
          src={process.env.REACT_APP_URL_HOW_IT_WORKS_BANNER}
          className="v2-hero-bg"
          alt="Mimo Cupido Casal"
          loading="eager"
        />
        <div className="v2-container">
          <div className="v2-hero-content">
            <h1>
              Relacionamento de alto padrão <br />
              <span className="v2-gold-text">Como funciona?</span>
            </h1>
          </div>
        </div>
      </div>

      <div className="v2-section v2-center">
        <p>
          Entenda como funciona a nossa plataforma de relacionamento de alto
          padrão, criada para conectar pessoas com objetivos claros, segurança e
          compatibilidade real. <br /> O Mimo Cupido utiliza um processo de
          curadoria para garantir conexões seguras, discretas e alinhadas ao
          estilo de vida dos nossos membros. <br />
          Embora o conceito de relacionamento de alto padrão esteja crescendo no
          Brasil, muitas pessoas ainda têm dúvidas sobre como funciona o
          processo de conexão. <br />
          Aqui você entende como funciona o cadastro, a curadoria de perfis e a
          experiência dentro da plataforma.
        </p>

        <Link to="/cadastro">
          <button className="btn-primary">
            <UserIcon />
            Solicitar Acesso Exclusivo
          </button>
        </Link>
      </div>

      <section className="v2-section">
        <h2>O primeiro passo: entenda o básico da nossa plataforma</h2>

        <div className="step-item">
          <h3>1. Cadastro</h3>
          <p>
            O primeiro passo é criar um perfil completo com informações reais e
            fotos atualizadas. Isso nos ajuda a garantir compatibilidade e
            aumentar suas chances de conexão com pessoas alinhadas ao seu
            perfil.
          </p>
        </div>

        <div className="step-item">
          <h3>2. Perfil e compatibilidade</h3>
          <p>
            Cada usuário pode indicar suas preferências e objetivos dentro da
            plataforma. Nosso sistema prioriza conexões baseadas em
            compatibilidade, estilo de vida e interesses em comum.
          </p>
        </div>

        <div className="step-item">
          <h3>3. Avaliação</h3>
          <p>
            Após o cadastro, os perfis passam por uma análise para garantir
            autenticidade, segurança e qualidade da comunidade. Esse processo
            ajuda a manter um ambiente seguro e exclusivo.
          </p>
        </div>

        <div className="step-item">
          <h3>4. Curadoria da comunidade</h3>
          <p>
            Trabalhamos com equilíbrio entre perfis para manter uma experiência
            justa e eficiente para todos os membros. Isso permite que as
            conexões sejam mais relevantes e com maior chance de sucesso.
          </p>
        </div>

        <div className="step-item">
          <h3>5. Aprovação</h3>
          <p>
            O tempo de análise pode variar de acordo com a demanda. Perfis
            completos e com fotos claras são priorizados no processo de
            aprovação.
          </p>
        </div>

        <div className="step-item">
          <h3>6. Conexões reais</h3>
          <p>
            Após aprovado, você poderá interagir com pessoas reais que buscam
            relacionamentos sérios, discretos e compatíveis com seu estilo de
            vida. A plataforma prioriza segurança, respeito e autenticidade em
            todas as interações.
          </p>
        </div>
      </section>

      <section className="v2-section">
        <div className="trust-item">
          <div>
            <span>✓</span>
            <p>Perfis verificados e analisados</p>
          </div>

          <div>
            <span>✓</span>
            <p>Moderação ativa da comunidade</p>
          </div>

          <div>
            <span>✓</span>
            <p>Proteção de dados e privacidade</p>
          </div>

          <div>
            <span>✓</span>
            <p>Usuários em todo o Brasil</p>
          </div>
        </div>
      </section>

      <section className="v2-section">
        <Accordion items={faqItems} />
      </section>

      <section className="v2-section v2-center">
        <ContactUs />
      </section>

      <section className="v2-section v2-center">
        <h2>Pronto para conhecer novas conexões?</h2>

        <p>
          Faça parte de uma comunidade de relacionamento de alto padrão, onde o
          matchmaking é baseado em compatibilidade, segurança e conexões reais
          com propósito.
        </p>

        <Link to="/cadastro">
          <button className="btn-about">Solicitar Acesso Exclusivo</button>
        </Link>
      </section>
    </div>
  );
};

export default HowItWorksScreen;
